import React from 'react';

export default function NotFoundLoggedOutPage() {

  return (
      <div className="lo-page lo-prose">
        <div className="lo-page-header">
          <h1>Page not found</h1>
        </div>

        <p>
          We did not find the page you requested.
          Please <a href="https://go.nzyme.org/contact" target="_blank">contact us</a> if you believe this is an
          error.
        </p>
      </div>
  )

}
